import { render, staticRenderFns } from "./addAiBot.vue?vue&type=template&id=072e5420&lang=pug"
import script from "./addAiBot.vue?vue&type=script&lang=js"
export * from "./addAiBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports